import { useEffect, useMemo, useState } from "react";
import {
  type FeatureFlagReadDto,
  type FeatureFlagUpsertCommandFeatureEnum,
} from "@/config/apiClient";
import { useFeatureFlags } from "./queries";

export const useGetIsFeatureActive = (
  feature: FeatureFlagUpsertCommandFeatureEnum
): {
  isActive: boolean;
  isLoading: boolean;
  metadata: FeatureFlagReadDto["metadata"];
} => {
  const [isLoading, setIsLoading] = useState(true);

  const { useGetFeatureFlags } = useFeatureFlags();
  const {
    data: featureFlags,
    isLoading: isLoadingFeatureFlags,
    isFetching: isFetchingFeatureFlags,
  } = useGetFeatureFlags();

  useEffect(() => {
    if (isLoadingFeatureFlags) {
      setIsLoading(isLoadingFeatureFlags);
    }
    if (isFetchingFeatureFlags) {
      setIsLoading(isFetchingFeatureFlags);
    } else {
      setIsLoading(false);
    }
  }, [isLoadingFeatureFlags, isFetchingFeatureFlags]);

  const isActive = useMemo(
    () =>
      Boolean(featureFlags?.data?.find) &&
      Boolean(
        featureFlags?.data?.find(
          (featureFlag) => featureFlag.feature === feature
        )?.isActive
      ),
    [featureFlags, feature]
  );

  const metadata = useMemo(
    () =>
      featureFlags?.data?.find((featureFlag) => featureFlag.feature === feature)
        ?.metadata,
    [featureFlags, feature]
  );

  return { isActive, isLoading, metadata };
};
